<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Statuts TPE constatés
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px"
                     large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export infos</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <AddGoogleMap :eMarker="eMarker" :locationMarkers="locationMarkers" :center="center" :iconColor="iconColor"
                        :path="pathMarkersTrace"/>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";
import AddGoogleMap from "./AddGoogleMap";
import Toolbar from "../Toolbar";

function cellRedRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.className = "red1"; // yellow and Green
}

function cellYellowRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.className = "yellow1"; // yellow and Green
}

function cellGreenRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.className = "green1"; // yellow and Green
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "statutsTPE",
  components: {
    HotTable,
    AddGoogleMap
  },
  data: function () {
    return {
      isMobile: isMobileDevice(),
      indMrk: 0,
      timerEnabled: true,
      timerCount: 5,
      pathMarkersTrace: [],
      pathMarkersTmp: [
        "14.710431429971402, -17.093568627913573",
        "14.718265424363295, -17.115768645964547",
        "14.731576437507188, -17.160024983847887",
        "14.733763227472394, -17.206532156064007",
        "14.737357173822124, -17.260020350681398",
        "14.759293629102906, -17.331656933920513"
      ],
      pathMarkersTerm: [
        {lat: 14.695459056155062, lng: -17.073601533124762}, //1
        {lat: 14.671857370776511, lng: -17.06425576693379},  //2
        {lat: 14.646142102864532, lng: -17.073723514313905}, //3
        {lat: 14.673031855181936, lng: -17.081855552051632} //4
      ],
      iconTerminal1: 'http://maps.google.com/mapfiles/kml/pal3/icon0.png',
      iconTerminal2: 'http://maps.google.com/mapfiles/kml/pal3/icon1.png',
      iconTerminal3: 'http://maps.google.com/mapfiles/kml/pal3/icon2.png',
      iconTerminal4: 'http://maps.google.com/mapfiles/kml/pal3/icon3.png',
      iconTerminal5: 'http://maps.google.com/mapfiles/kml/pal3/icon4.png',
      eMarker: false,
      locationMarkers: [],
      center: {},
      iconColor: null,
      disableMainBtn: false,
      lastHighlitedRow: null,
      loading: false,
      toObject: [],
      file: "",
      excelData: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "275px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: true,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          "Id", "Numéro TPE", "Affectation", "Date remontée", "Batterie", "Connectivité", "GPS", "Date création"
        ],
        columns: [
          {title: "Id", width: "80px"},
          {title: "Numéro TPE", width: "100px"},
          {title: "Affectation", width: "100px"},
          {
            title: "Date remontée",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date"
          },
          {title: "Batterie", width: "200px"},
          {title: "Connectivité", width: "200px"},
          {title: "GPS", width: "160px"},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};

          if (col === 4) {
            let cellValue = this.instance.getSourceDataAtCell(row, 4);

            if (cellValue === null)
              return cellProperties;

            cellValue = cellValue.split('%').join('')
            cellValue = parseInt(cellValue, 10)

            if (cellValue >= 50) {
              cellProperties.renderer = cellGreenRenderer;
            } else if ((cellValue >= 25) && (cellValue < 50)) {
              cellProperties.renderer = cellYellowRenderer;
            } else {
              cellProperties.renderer = cellRedRenderer;
            }
          } else if (col === 5) {
            let cellValue = this.instance.getSourceDataAtCell(row, 5);

            if (cellValue === null)
              return cellProperties;

            if (cellValue === "En ligne") {
              cellProperties.renderer = cellGreenRenderer;
            } else {
              cellProperties.renderer = cellRedRenderer;
            }
          }

          return cellProperties;
        }
      }
    }
  },
  created() {
    this.getData()
  },

  mounted() {
    this.center = new Object({lat: 14.67299, lng: -17.07284})

    this.addManualLocationMarker(14.695459056155062, -17.073601533124762, this.iconTerminal1, "AIBD", "76.098.45.23", "123.34.54.65", "TSA Aérogare")
    this.addManualLocationMarker(14.671857370776511, -17.06425576693379, this.iconTerminal2, "AIBD", "76.098.45.26", "123.34.54.68", "ASSA")
    this.addManualLocationMarker(14.646142102864532, -17.073723514313905, this.iconTerminal3, "AIBD", "76.098.45.24", "123.34.54.66", "TSA VIP")
    this.addManualLocationMarker(14.673031855181936, -17.081855552051632, this.iconTerminal4, "AIBD", "76.098.45.25", "123.34.54.67", "TSA Zone 5")
  },

  watch: {
    timerCount: {
      handler() {
        if (this.timerEnabled && (this.indMrk < this.pathMarkersTmp.length)) {
          setTimeout(() => {
            this.addPathMarkersTerm(this.pathMarkersTmp[this.indMrk++], "Dakar - AIBD", "76.985.25.76", "96.435.65.35", "Terminal Bus", this.iconTerminal5)
            this.timerCount++;
          }, 5000);
        } else {
          setTimeout(() => {
            if (this.timerCount !== 1)
              this.timerCount = 1;
            else
              this.timerCount = 0;
          }, 5000);
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    },
  },

  methods: {
    play() {
      this.timerEnabled = true;
    },

    pause() {
      this.timerEnabled = false;
    },
    addPathMarkersTerm(strMarker, city, phone, ip, full_name, iconColor) {
      let ind = strMarker.search(",");

      let lat = strMarker.substring(0, ind).trim();
      let lng = strMarker.substring(ind + 1, strMarker.length).trim();

      this.addManualLocationMarker(parseFloat(lat), parseFloat(lng), iconColor, city, phone, ip, full_name)
    },
    addManualLocationMarker(lat, lng, iconColor, city, phone, ip, full_name) {
      const marker = {
        lat: lat,
        lng: lng,
        city: city,
        phone: phone,
        ip: ip,
        full_name: full_name,
        iconColor: iconColor
      };
      this.locationMarkers.push({position: marker, icon: iconColor});
      //this.center = marker;
      this.iconColor = iconColor;

      this.handleExample()
    },
    simulateEmitEventToChild() {
      this.eMarker = !this.eMarker;
    },
    handleExample() {
      this.simulateEmitEventToChild();
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    getData() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/statutsTPE/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              let connectivite
              let dateTPE = new Date(item["dateHeure"])
              let dateActual = new Date()

              const diffTime = Math.abs(dateActual - dateTPE);
              const diffMin = Math.ceil(diffTime / (1000 * 60));

              if ((diffMin >= 0) && (diffMin <= 90)) {
                connectivite = "En ligne"
              } else {
                connectivite = "Hors ligne"
              }

              tabArray.push([
                item["id"],
                item["numeroTPE"],
                item["affectation"],
                moment(item["dateHeure"]).format("DD-MM-YYYY HH:mm:ss"),
                item["infosBattery"],
                connectivite,
                item["gpsCoordinates"],
                moment(item["creationDate"]).format("DD-MM-YYYY HH:mm:ss")
              ])
             })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData(this.depthVal)
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Statuts_TPE_remontés") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Statuts_TPE_remontés.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },
  },
};
</script>
<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

/*    .red {
        text-align: center;
        color: #f5f5f5;
        background-color: #e64a19 !important;
        font-style: normal !important;
    }

    .yellow {
        text-align: center;
        background-color: #ffff8d !important;
        font-style: normal !important;
    }

    .green1 {
        text-align: center;
        color: #f5f5f5;
        background-color: #009688 !important;
        font-style: normal !important;
    }*/

.red1 {
  text-align: center;
  color: #dd2c00 !important;
  font-style: normal !important;
}

.yellow1 {
  text-align: center;
  color: #ffa726 !important;
  font-style: normal !important;
}

.green1 {
  text-align: center;
  color: #009688 !important;
  font-style: normal !important;
}
</style>

